export default (function () {
  // 设置rem单位大小
  (function (doc, win) {
    var docEl = doc.documentElement
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    var windowInitHeight = docEl.clientHeight || window.screen.height

    var recalc = function () {
      var clientWidth = docEl.clientWidth || window.screen.width
      var clientHeight = docEl.clientHeight || window.screen.height
      if (!clientWidth) return
      var maxWidth = 600
      clientWidth = clientWidth < maxWidth ? clientWidth : maxWidth
      docEl.style.fontSize = clientWidth / 10 + 'px'

      let resizeFixedToStatic = document.querySelector('.resizeFixedToStatic')
      if (!resizeFixedToStatic) return
      resizeFixedToStatic.style.position = clientHeight + 50 < windowInitHeight ? 'static' : 'fixed'
    }
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  })(document, window)
})()



// WEBPACK FOOTER //
// ./src/utils/rem.js